'use client';

import ProtectedRoute from '../../components/ProtectedRoute';
import LogoSection from '../../components/LogoSection';

export default function LoggedOutLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ProtectedRoute requireAuth={false}>
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', width: '100%', margin: 0, padding: 0 }}>
        <LogoSection />
        <main style={{ flex: 1, width: '100%', margin: 0, padding: 0 }}>
          {children}
        </main>
      </div>
    </ProtectedRoute>
  );
} 